import React from 'react';
import { Link } from 'react-router-dom';
import { categories } from '../../data/collections';
import { products } from '../../data/products';
import { fromPrice } from '../../utils/products';
import { formatPrice } from '../../utils/currency';
export function CategoryShortcuts() {
  return <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-24" data-id="element-52" data-mp="2jdkewd2ar09t">
      <h2 className="text-3xl font-semibold tracking-display text-ink sm:text-4xl" data-id="element-53" data-mp="2jfnb5eu1lpmz">Shop per categorie</h2>
      <ul className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-7 lg:gap-4" data-id="element-54" data-mp="2ad5o4y6kcsyx">
        {categories.map(c => {
        const items = products.filter(p => p.category === c.id);
        const min = Math.min(...items.map(fromPrice));
        return <li key={c.id} data-id="element-55" data-mp="20nm59siuoz42">
              <Link to={`/collectie/${c.id}`} className="group flex h-full flex-col rounded-2xl border border-line bg-white p-3 transition-colors duration-150 hover:border-ink" data-id="element-56" data-mp="1mnjpcbu3sfrg">
                <img src={items[0]?.image} alt="" className="aspect-square w-full rounded-xl bg-surface object-cover" data-id="element-57" data-mp="2z2jud1gsbpeq" />
                <span className="mt-3 text-sm font-semibold text-ink" data-id="element-58" data-mp="2u36zpujo9e1l">{c.title}</span>
                <span className="mt-auto pt-0.5 text-xs text-muted" data-id="element-59" data-mp="391ixy5mp0uuv">vanaf {formatPrice(min)}</span>
              </Link>
            </li>;
      })}
      </ul>
    </section>;
}